import { createContext, useState, useEffect } from 'react'
import { unfolder } from './CryptoMethods'

export const projectContext = createContext()

export function ProjectProvider({ children }) {
  const [project, setProject] = useState({ metadata: { description: [] } })

  useEffect(() => {
    const ciphertext = localStorage.getItem('HashSelectedProject')
    if (ciphertext) {
      try {
        setProject(unfolder(ciphertext, 'IANestingKey'))
      } catch (error) {
        localStorage.clear()
      }
    }
  }, [])

  return (
    <projectContext.Provider value={[project, setProject]}>
      {children}
    </projectContext.Provider>
  )
}
